module.exports = __webpack_public_path__ + "img/zammad-logo.ef9116fe.png";